module.exports = __webpack_public_path__ + "static/Group-fb5e7819c65a769cf7121a179ec856b9.png";